export const categories = [
  {
    id: 'yexing-liliang',
    name: '野性力量',
    slug: 'yexing-liliang',
    description: '释放内在的原始力量，以大胆的剪裁、深沉的色彩和强势的轮廓，宣告你的存在。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20of%20a%20woman%20in%20bold%20structured%20black%20blazer%20with%20sharp%20shoulders%20and%20deep%20crimson%20accents%2C%20dramatic%20lighting%2C%20powerful%20stance%2C%20minimalist%20studio%20background%20with%20warm%20cream%20tones%2C%20luxury%20fashion%20aesthetic%2C%20high%20contrast%2C%20editorial%20style&width=600&height=800&seq=cat-wild-power&orientation=portrait',
    articleCount: 12,
  },
  {
    id: 'youya-panni',
    name: '优雅叛逆',
    slug: 'youya-panni',
    description: '在优雅与反叛之间找到完美平衡，用古典元素碰撞现代态度，演绎不拘一格的风格。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20photography%20of%20a%20woman%20wearing%20an%20elegant%20silk%20dress%20paired%20with%20chunky%20combat%20boots%2C%20contrasting%20soft%20feminine%20fabric%20with%20edgy%20accessories%2C%20warm%20golden%20hour%20lighting%2C%20minimalist%20cream%20background%2C%20editorial%20fashion%20style%2C%20luxurious%20texture%20details&width=600&height=800&seq=cat-elegant-rebel&orientation=portrait',
    articleCount: 9,
  },
  {
    id: 'ziyou-linghun',
    name: '自由灵魂',
    slug: 'ziyou-linghun',
    description: '不被任何框架所定义，以流动的线条、自然的材质和无拘的搭配，诠释真正的自由。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20of%20a%20woman%20in%20flowing%20bohemian%20layered%20outfit%20with%20natural%20linen%20textures%20and%20earthy%20tones%2C%20moving%20freely%20in%20an%20open%20space%2C%20soft%20natural%20light%2C%20minimalist%20cream%20studio%20background%2C%20artistic%20fashion%20photography%2C%20dreamy%20atmosphere&width=600&height=800&seq=cat-free-soul&orientation=portrait',
    articleCount: 8,
  },
  {
    id: 'anye-meili',
    name: '暗夜魅力',
    slug: 'anye-meili',
    description: '拥抱夜色中的神秘与魅惑，以蕾丝、皮革与金属光泽，释放令人无法忽视的致命吸引力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20photography%20of%20a%20woman%20in%20a%20black%20lace%20dress%20with%20metallic%20gold%20jewelry%20accents%2C%20dark%20moody%20lighting%20with%20warm%20highlights%2C%20luxurious%20textures%2C%20minimalist%20cream%20studio%20background%2C%20editorial%20fashion%20style%2C%20mysterious%20elegant%20aesthetic&width=600&height=800&seq=cat-dark-glamour&orientation=portrait',
    articleCount: 10,
  },
  {
    id: 'jijin-jiexian',
    name: '极简界限',
    slug: 'jijin-jiexian',
    description: '以最少的元素表达最强烈的态度，用精准的线条、纯粹的色彩突破审美的边界。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20of%20a%20woman%20in%20a%20minimalist%20structured%20white%20shirt%20dress%20with%20sharp%20architectural%20lines%2C%20clean%20geometric%20silhouette%2C%20soft%20studio%20lighting%2C%20warm%20cream%20minimalist%20background%2C%20modern%20luxury%20fashion%20aesthetic%2C%20sophisticated%20composition&width=600&height=800&seq=cat-minimal-edge&orientation=portrait',
    articleCount: 7,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};